// extracted by css-extract-rspack-plugin
export default {"root":"root-2mbdc","wrapper":"wrapper-OeUnz","icon":"icon-1qEr2","content":"content-2-6kI","copy":"copy-2zVp_","align":"align-1weaZ"};